<template>
  <div>
    <v-container class="global-margin">
      <v-breadcrumbs :items="breadcrumbs" class="breadcrumbs pl-0" large></v-breadcrumbs>
      <v-row align="center" justify="center">
        <v-col cols="12" md="8">
          <v-img max-width="260px" :src="require('@/assets/img/plava.svg')" class="mb-6"></v-img>
          <p>
            SUMIT Školarac je platforma za učenje na daljinu, koja omogućava otvaranje i pohađanje online tečajeva, komunikaciju, prezentaciju sadržaja, provjeru stečenog znanja, predaju i kontrolu zadaća te praćenje sudjelovanja. Na Školarac se možete prijaviti putem
            <b>@skole.sum.ba</b> korisničkog računa.
          </p>
          <p>
            Školarac je sustav za upravljanje učenjem, odnosno programski alat za izradu e-kolegija,
            održavanje nastave na daljinu i kombinirane nastave uživo i na daljinu.
            Školarac je zasnovan na alatu Moodle, programskoj podršci (eng. software) otvorenog koda koji
            je licenciran i besplatan, što je pridonijelo njegovoj velikoj popularnosti i kontinuiranom razvoju.
            Moodle danas predstavlja najpopularniju platformu ove namjene koju koriste brojni korisnici u
            svijetu.
          </p>
          <p>SUMIT u svrhu pružanju podrške održavanju nastave na daljinu i kombinirane nastave osigurava:</p>
          <ul>
            <li>pohađanje gotovih e-kolegija (virtualnih učionica) i korištenje materijala za samostalno učenje</li>
            <li>otvaranje praznih tečajeva koje nastavnici sami nadopunjuju sadržajem</li>
            <li>održavanje nastave na daljinu i kombinirane nastave uživo i na daljinu putem vlastitih</li>
            <li>kolegija</li>
            <li>podršku korisnicima</li>
          </ul>
          <h2 class="headline pt-5 pb-3">Prijava u Školarac</h2>
          <p>
            Sustavu Školarac pristupate uz pomoć mrežnog preglednika upisivanjem mrežne adrese
            <a style="color: #084776 !important;" href="https://skolarac.sum.ba" target="_blank">https://skolarac.sum.ba</a>. Nakon upisivanja mrežne adrese otvara nam se sučelje za login.
            <b>Prijava na sustav vrši se pomoću @skole.sum podataka</b>.
          </p>
        </v-col>
        <v-col cols="12" md="8" v-for="(item, i) in upute" :key="i">
          <v-card flat :href="item.link">
            <v-row>
              <v-col cols="10">
                <v-card-title style="color: #084776">{{item.title}}</v-card-title>
                <v-card-subtitle>{{item.text}}</v-card-subtitle>
              </v-col>
              <v-col cols="2">
                <v-card-text>
                  <v-icon class="mt-3" color="#084776">fas fa-chevron-right</v-icon>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "GSuite",
  data() {
    return {
      upute: [
        {
          title: "Pristup usluzi",
          text: "Kliknite ovdje za pristup usluzi",
          link: "https://skolarac.sum.ba/login/login.html"
        },
        {
          title: "Kako se prijaviti u sustav?",
          text: "Kliknite ovdje za preuzimanje uputa uputa (.pdf)",
          link: "https://skole.sum.ba/admin/dokumenti/Upute-za-administratore.pdf"
        },
{
          title: "Kreiranje i brisanje kategorija (razreda)",
          text: "Kliknite ovdje za pregled uputa (VIDEO)",
          link: "https://www.youtube.com/watch?v=NwUOeGCfXTI&feature=youtu.be"
        },

        {
          title: "Upisivanje i ispisivanje sudionika (učenika)",
          text: "Kliknite ovdje za pregled uputa (VIDEO)",
          link: "https://www.youtube.com/watch?v=gIl-iqKnIj8&feature=youtu.be "
        },

        {
          title: "Odobravanje i brisanje e-kolegija (predmeta)",
          text: "Kliknite ovdje za pregled uputa (VIDEO)",
          link: "https://www.youtube.com/watch?v=Qz1V3zBBvgU&feature=youtu.be"
        },
        
        {
          title: "Upute za kreiranje kategorija",
          text: "Kliknite ovdje za preuzimanje uputa uputa (.pdf)",
          link: "https://skole.sum.ba/admin/dokumenti/upute-za-kreiranje-kategorija.pdf"
        },
        {
          title: "Upute za nastavnike",
          text: "Kliknite ovdje za preuzimanje uputa (.pdf)",
          link: "https://www.carnet.hr/wp-content/uploads/2020/03/Moodle-upute-za-u%C4%8Ditelje-i-nastavnike.pdf"
        },
        {
          title: "Upute za učenike",
          text: "Kliknite ovdje za preuzimanje uputa (.pdf)",
          link: "https://www.carnet.hr/wp-content/uploads/2020/03/Moodle-upute-za-u%C4%8Denike-1.pdf"
        }
      ],
      breadcrumbs: [
        {
          text: 'Naslovnica',
          disabled: false,
          to: '/'
        },
        {
          text: 'Školarac',
          disabled: true,
        },
      ],
    };
  }
};
</script>

<style lang="scss" scoped>
.skolarac {
  margin-top: 150px;
}
@media (max-width: 768px) {
  .skolarac {
    margin-top: 120px !important;
  }
}
.v-card__text, .v-card__title {
  word-break: normal;
}
</style>
